import { Text, HStack, Stack, Spacer } from '@chakra-ui/react';

import { useUserStore } from '@store/app.store';
import { useFeedPageFilters } from '@util/hooks';
import FeedFilterAccordion from '@components/feed/feed-filter-accordion.component';
import FeedFilterTabs from '@components/feed/feed-filter-tabs.component';
import FeedFilterAccordionStackComponent from './feed-filter-accordion-stack.component';

export default function FeedFilterSidebar({ tab }) {
  const { hasActiveFilters, handleResetFilters } = useFeedPageFilters();
  const user = useUserStore((state) => state.user);
  const isGuest = user?.isGuest;

  return (
    <Stack
      p={11}
      gap={6}
    >
      <HStack>
        <Text variant='content-section-header'>Filter by</Text>
        {hasActiveFilters && (
          <>
            <Spacer />
            <Text
              fontSize='sm'
              color='brandPrimary.primary'
              onClick={handleResetFilters}
              cursor='pointer'
              _hover={{ bgColor: 'none' }}
            >
              Clear Filters
            </Text>
          </>
        )}
      </HStack>
      {!isGuest && <FeedFilterTabs tab={tab} />}
      <FeedFilterAccordion tab={tab} />
      <FeedFilterAccordionStackComponent tab={tab} />
    </Stack>
  );
}
